module.exports = __webpack_public_path__ + "static/media/success.1fbb579a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/success.svg
// module id = 3094
// module chunks = 0